import React from "react"

export const PageLoader: React.FC = () => <div className="c-loader--tertiary"> Loading... </div>
